<template>
  <div class="employeeList">
    <!-- 重置密码 -->
    <div class="resetPassword">
      <el-dialog title="重置密码" :visible.sync="resetPasswordVisible" :close-on-click-modal="false">
        <el-form ref="resetPasswordForm" :model="resetPasswordForm" :rules="resetPasswordRules">
          <el-form-item label="" prop="password">
            <el-input v-model="resetPasswordForm.password" show-password maxlength="16" placeholder="新密码"></el-input>
          </el-form-item>
          <el-form-item label="" prop="repeatPassword">
            <el-input v-model="resetPasswordForm.repeatPassword" show-password maxlength="16" placeholder="确认密码"></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button size="small" @click="resetPasswordVisible=false">取 消</el-button>
            <el-button size="small" type="primary" @click="resetPasswordSubmit('resetPasswordForm')">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div v-loading='employeeListLoading'  v-permission="'enterprise:employee:list'">
      <div class="top">
        <div class="title"><span>公司ID：{{getEmployeeListData.id}}</span><span>公司名称：{{getEmployeeListData.enterpriseName}}</span></div>
      </div>
      <div class="tableBox">
        <el-table :data="employeeList" border stripe>
          <el-table-column prop="id" label="序号" fixed></el-table-column>
          <el-table-column prop="roleName" label="员工角色"></el-table-column>
          <el-table-column prop="employeeName" label="员工姓名"></el-table-column>
          <el-table-column prop="userName" label="邮箱"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label="操作" min-width="120" v-permission="'enterprise:employee:password'">
            <template slot-scope="scope">
              <div class="operating">
                <span @click="resetPassword(scope.row.id)">重置密码</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging-box" v-if="pageTotal>0">
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[ 10, 20, 40, 80, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 表单验证
import { notNullable, passwordFormat } from '@/components/form/formValidation'
// 公用
import { getTime } from '@/components/public'

export default {
  name: 'customerManage',
  data () {
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (this.resetPasswordForm.password !== this.resetPasswordForm.repeatPassword) {
        return callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 员工列表
      employeeList: [],
      employeeListLoading: true,
      employeeListParam: {},
      // 重置密码
      resetPasswordVisible: false,
      resetPasswordId: '',
      resetPasswordForm: {
        password: '',
        repeatPassword: ''
      },
      resetPasswordRules: {
        password: [
          notNullable('请填写新密码'),
          passwordFormat('密码')
        ],
        repeatPassword: [
          notNullable('请填写确认密码'),
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      }

    }
  },
  props: {
    getEmployeeListData: {
      type: Object,
      required: true
    }
  },
  created () {
  },
  mounted () {
    if (this.getEmployeeListData.id === 0) {
      this.$message({
        message: '缺少必要信息，即将为您跳转列表页',
        type: 'warning',
        duration: 1000
      })
      let _this = this
      setTimeout(function () {
        _this.$router.push('/operationManage/customerManage')
      }, 1000)
    } else {
    // 获取员工列表
      this.getEmployeeList(this.currentPage, this.pagesize)
    }
  },
  watch: {
    // 监测弹窗
    resetPasswordVisible (to, form) {
      if (to === false) {
        this.resetForm('resetPasswordForm')
      }
    }
  },
  methods: {
    getEmployeeList (currentPage, pagesize) {
      this.employeeListParam = {
        id: this.getEmployeeListData.id,
        pageNum: currentPage,
        pageSize: pagesize
      }
      this.$service.post('/api/enterprise/employee/list', this.employeeListParam).then(res => {
        res.result.pageData.forEach((item, index) => {
          item.createTime = getTime(new Date(item.createTime))
        })
        this.employeeList = res.result.pageData
        this.pageTotal = res.result.total
        this.employeeListLoading = false
      }).catch(Err => {
        this.employeeListLoading = false
      })
    },
    // 重置密码
    resetPassword (id) {
      this.resetPasswordId = id
      this.resetPasswordVisible = true
    },
    resetPasswordSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.resetPasswordForm.password)
          // console.log(this.$md5(this.resetPasswordForm.password + ''))
          this.$service.post('/api/enterprise/employee/password', {
            'employeeId': this.resetPasswordId,
            'passWord': this.$md5(this.resetPasswordForm.password + '')
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.resetPasswordVisible = false
          }).catch(Err => {

          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.pagesize = size
      this.getEmployeeList(this.currentPage, size)
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getEmployeeList(currentPage, this.pagesize)
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }

}
</script>

<style lang="less">
  @import './../../styles/operationManage/employeeList.less';
</style>



// WEBPACK FOOTER //
// src/views/operationManage/employeeList.vue